import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import { AvatarDisplay } from '../../utils/avatars';
import { getMemberCenterNavSections } from '../../utils/memberNavigation';
import PageHeader from './PageHeader';
import './MemberCenterLayout.css';

export default function MemberCenterLayout({
  title,
  subtitle,
  activeKey,
  children,
  topLevel = false,
  hideSidebar = false,
  headerAction = null,
  contentClassName = ''
}) {
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);
  const profile = currentUser?.profile || {};
  const sections = getMemberCenterNavSections(profile.role === 'admin');

  const goTo = path => {
    navigate(path);
  };

  const renderSections = () => sections.map(section => (
    <div className="member-center-nav__section" key={section.label}>
      <div className="member-center-nav__label">{section.label}</div>
      {section.items.map(item => {
        const Icon = item.icon;
        const isActive = item.key === activeKey;
        return (
          <button
            key={item.key}
            type="button"
            className={`member-center-nav__item${isActive ? ' member-center-nav__item--active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => goTo(item.path)}
          >
            <Icon size={19} aria-hidden="true" />
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>
  ));

  return (
    <div className="member-center-page">
      <PageHeader
        title={title}
        subtitle={subtitle}
        showBack={!topLevel}
        backLabel="返回我的個人資料"
        onBack={() => navigate('/profile')}
        rightAction={headerAction}
        maxWidth={1240}
      />

      <div className={`member-center-shell${hideSidebar ? ' member-center-shell--single' : ''}`}>
        {!hideSidebar && <aside className="member-center-sidebar" aria-label="會員中心導覽">
          <div className="member-center-summary">
            <AvatarDisplay avatarId={profile.avatar || 'avatar1'} size={64} />
            <div className="member-center-summary__copy">
              <strong>{profile.name || 'JoinU 會員'}</strong>
              <span>會員中心</span>
            </div>
          </div>
          <nav className="member-center-nav">
            {renderSections()}
          </nav>
        </aside>}

        <main className={`member-center-content${contentClassName ? ` ${contentClassName}` : ''}`}>
          {children}
        </main>
      </div>
    </div>
  );
}
